(function () {
  'use strict';
  function init() {
    const title = document.getElementById('product-title');
    const source = document.querySelector('[data-product-title-config]');
    const list = document.querySelector('[data-product-title-inclusions]');
    const subtitle = document.querySelector('[data-product-title-detail]');
    if (!title || !source || title.dataset.titleSummaryReady) return;
    let config;
    try { config = JSON.parse(source.getAttribute('data-product-title-config')); } catch (_) { return; }
    title.dataset.titleSummaryReady = 'true';
    let fitment = window.__partifyNativeFitmentLastResult;
    const clean = value => {
      if (Array.isArray(value)) return value.map(clean).filter(Boolean).join(' / ');
      const node = document.createElement('textarea');
      node.innerHTML = String(value || '').replace(/<script\b[^>]*>[\s\S]*?<\/script>/gi, '').replace(/<[^>]*>/g, '').replace(/</g, '&lt;');
      return node.value.replace(/\s+/g, ' ').trim();
    };
    function render(detail) {
      if (detail !== undefined) fitment = detail;
      const radio = document.querySelector('input[name="quality_type"]:checked:not(:disabled)');
      const qualityValue = String(radio?.value || config.initialQuality || '').toLowerCase();
      const key = ['aftermarket', 'capa', 'oem'].find(key => qualityValue.includes(key)) || (/\bOEM\b/i.test(config.canonical) ? 'oem' : /\bCAPA\b/i.test(config.canonical) ? 'capa' : '');
      const product = config.enabled && config.qualities?.[key] || config;
      let next = clean(product.canonical || config.canonical);
      let shortened = false;
      if (config.enabled) {
        const type = clean(product.type || config.type);
        const position = type ? next.toLowerCase().indexOf(type.toLowerCase()) : -1;
        if (position >= 0) {
          next = next.slice(0, position + type.length).replace(/\b(?:CAPA(?:\s+Certified)?|OEM)\b/gi, '').replace(/\s+/g, ' ').trim();
          const quality = key === 'capa' ? 'CAPA' : key === 'oem' ? 'OEM' : '';
          if (quality) next += ' ' + quality;
          const sku = clean(radio?.dataset.qualitySku || product.sku || config.sku);
          if (sku) next += ' - ' + sku;
          shortened = true;
        }
      }
      const year = fitment?.state === 'success' ? String(fitment.vehicle?.year || '').trim() : '';
      if (/^\d{4}$/.test(year)) {
        if (!/^\d{4}\s*-\s*\d{4}\b/.test(next)) {
          next = /^\d{4}\b/.test(next) ? next.replace(/^\d{4}\b/, year) : year + ' ' + next;
        }
      }
      if (title.textContent.trim() !== next) title.textContent = next;
      const sticky = document.querySelector('#partify-sticky .ps-title');
      if (sticky && sticky.textContent !== next) sticky.textContent = next;
      if (!list) return;
      const groups = new Map();
      const seen = new Set();
      if (shortened) for (const option of product.inclusions || []) {
        if (!option) continue;
        let label = clean(option.label);
        if (!label) continue;
        if (/^(yes|no|true|false)$/i.test(label) && option.question) label = clean(option.question) + ' ' + label;
        const token = label.toLowerCase();
        if (seen.has(token)) continue;
        seen.add(token);
        const group = clean(option.group) || token;
        if (!groups.has(group)) groups.set(group, []);
        groups.get(group).push(label);
      }
      const labels = Array.from(groups.values(), values => values.join(' / '));
      if (JSON.stringify(labels) !== list.dataset.labels) {
        list.replaceChildren(...labels.map(label => {
          const item = document.createElement('li');
          item.textContent = label;
          return item;
        }));
        list.dataset.labels = JSON.stringify(labels);
      }
      list.hidden = labels.length === 0;
      const detailText = shortened && !labels.length ? clean(product.detail) : '';
      if (subtitle) {
        subtitle.textContent = detailText;
        subtitle.hidden = !detailText;
      }
      title.classList.toggle('product-title--with-detail', labels.length > 0 || !!detailText);
    }
    window.PartifyProductTitle = { render };
    render(fitment);
    document.addEventListener('partify:native-fitment-resolved', event => render(event.detail));
    for (const event of ['partify:pdp-quality-settled', 'variantsUpdated']) document.addEventListener(event, () => render());
    document.addEventListener('change', event => {
      if (event.target.matches('input[name="quality_type"], #variant-selector')) render();
    });
    if (config.enabled) new MutationObserver(() => render()).observe(title, { childList: true, characterData: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
